import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleDashed } from '@fortawesome/pro-regular-svg-icons';
import { type RequestType } from '../../types';
import { useTranslation } from '../../i18n/i18n';

type StepsCardProps = {
  clientName?: string;
  requestType?: RequestType;
};

/** "Steps to complete" card shown in the sidebar. */
export default function StepsCard({ clientName, requestType }: StepsCardProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4">
      <h3 className="text-base font-semibold text-sidebar-foreground leading-6">
        {t('sidebar.stepsTitle')}
      </h3>
      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-3 rounded-md border border-border bg-card px-4 py-3">
          <FontAwesomeIcon
            icon={faCircleDashed}
            className="size-4 shrink-0 text-card-foreground"
          />
          <span className="flex-1 truncate text-sm font-medium text-card-foreground">
            {requestType === 'issuance'
              ? t('sidebar.stepReceiveData', {
                  clientName: clientName ?? t('sidebar.defaultClientName'),
                })
              : requestType === 'authentication'
                ? t('sidebar.stepAuthenticate', {
                    clientName: clientName ?? t('sidebar.defaultClientName'),
                  })
                : requestType
                  ? t('sidebar.stepShareData', {
                      clientName: clientName ?? t('sidebar.defaultClientName'),
                    })
                  : t('sidebar.stepGeneric')}
          </span>
        </div>
      </div>
    </div>
  );
}
